import { render, staticRenderFns } from "./Splice.vue?vue&type=template&id=8b632cb2&scoped=true&"
import script from "./Splice.vue?vue&type=script&lang=js&"
export * from "./Splice.vue?vue&type=script&lang=js&"
import style0 from "./Splice.vue?vue&type=style&index=0&id=8b632cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b632cb2",
  null
  
)

export default component.exports